module.exports = __webpack_public_path__ + "img/4-fourImg.84b49847.png";